import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import Routing from "./Routes";

function App() {
  return (
    <>
      <ToastContainer
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        position="top-center"
      />
      <Routing />
    </>
  );
}

export default App;
